<template lang="pug">
.home
	img.cowardly-image(src="../assets/images/enigma.jpg" style="filter: contrast(45%)")
	.hero-text

		h3
			i.material-icons.md-96 wifi
		h1 Those Radio Days
		h2 A Tribute to Dolores Haze
		h3 Yottawatts and Terahertz
		a.btn.btn-secondary.btn-lg.mt-4(href='/transistor') Phone Home Marconi

</template>
<script>
import HelloWorld from '@/components/HelloWorld.vue'

export default {
	name: 'Home',
	components: {
		HelloWorld
	}
}
</script>

<style>

body, html {
	height: 100%;
	width: 100%;
}

.container {
	width: 100%;
}

#bg {
	position: fixed;
	top: 0;
	left: 0;
	min-width: 100%;
	min-height: 100%;
	filter: grayscale(100%) contrast(40%);
	background-color: #848482;
	background-blend-mode: multiply;
}

.home {
	height: 100%;
	width: auto;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-align: center;
}

.cowardly-image {
  background: url(../assets/images/machiine-one.jpg);
  height: 100%;
  width: 100vw;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  background-color: #6699cc;
  background-blend-mode: multiply;
}

.hero-text {
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
}

</style>